// Vista de creación de una prorroga 

// Imports 
import React, {createRef} from 'react';
import {Card, Form, Input, Button, DatePicker, Breadcrumb, Descriptions,Row, Col, Table, Spin, Divider} from 'antd';
import {FormularioProrroga, getIdFuncionario, datosProrroga} from "./VisitConsumer";
import 'antd/dist/antd.css';
import moment from 'moment';
import {Modal} from "antd/lib/index";
import {ExclamationCircleOutlined, CheckCircleTwoTone, CloseCircleTwoTone} from '@ant-design/icons';

const {TextArea} = Input;
const {RangePicker} = DatePicker;
const {confirm} = Modal;
const {Column} = Table;
const form = createRef();
const API_URL = window.ENV.API_URL+'';

//Componente de Formulario de   Prorroga 
class FormProrroga extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOk: false,
            modalNotOk : false,
            submitButtonload: false,
            modalProrrogaOk: false
        }

    };

    //Función para tener paises a partir de su id 
    parseRut = rutP =>{
        if(rutP != null){
            let flag_0 = 0;
            let rut_data = rutP;
            let rutPasaporte = '';
            if(rut_data[0] != 'P'){
                for (let i = 0; i < rut_data.length; i++) {
                    if(rut_data[i] != 0){
                        flag_0 = 1;
                    }
                    if(flag_0 == 1){
                        if(i < rut_data.length-1){
                            rutPasaporte = rutPasaporte + rut_data[i]
                        }else{
                            rutPasaporte = rutPasaporte + '-' + rut_data[i]
                        }
                    }
                }
            }else{
                rutPasaporte = rut_data;
            }
            return rutPasaporte;
        }
    }
    datosCampos= () =>{
        console.log("fields:",form.current.getFieldValue())
    }

    // Formulario
    render() {
        const items = [];
        const showModalOk = () => {
            this.setState({
                modalOk: true,
            });
        };
    
        const showModalNotOk = () => {
            this.setState({
                modalNotOk: true,
            });
        };
        const hideModalNotOk = () => {
            this.setState({
                modalNotOk: false,
                submitButtonload: false,
            });
        };

        const showModalProrrogaOk = () => {
            this.setState({
                modalProrrogaOk: true,
            });
        }

        const hideModalProrrogaOk = () => {
            this.setState({
                modalProrrogaOk: false,
                submitButtonload: false,
            });
        };

        const buttonNotLoading = () => {
            this.setState({
                submitButtonload: false,
            });
        };

        const onFinish = values => {
            this.setState({submitButtonload: true})
            values["id_visita"] = window.ENV.API_URL+"/visita/"+this.props.visits[0].ID_VISITA+"/";
            const pase_visita = this.props.visits[0].ID_VISITA;
            confirm({
                okText: 'Ok',
                cancelText: 'Cancelar',
                content: <div><div style={{textAlign:"center", marginBottom: "40px"}}><ExclamationCircleOutlined style={{fontSize: "60px", color: "#FFBA5C"}}/></div><div style={{fontSize: "19px", color:"#8190A5", marginBottom: "20px", textAlign:"center"}}>¿Está seguro de modificar la fecha de término de esta visita?</div></div>,
                cancelButtonProps: {className: 'global-secundario-button'},
                okButtonProps: {className: 'global-principal-button'},
                width:"600px",
                onOk() {
                    FormularioProrroga(values,pase_visita).then(function (response) {
                        if(response.data[0].ingresado){
                            showModalOk()
                        } else {
                            showModalProrrogaOk()
                        }
                    }).catch(function (error) {
                        showModalNotOk()
                    });
                },
                onCancel() {
                    buttonNotLoading()
                },
            });
        };
        
        //Mostramos el form resultante para cada rut que encuentre en la búsqueda 
        for (const [index, value] of this.props.visits.entries()) {
            items.push(
                <div key={index}>
                    <Descriptions column={2} title="Información de visita">
                        <Descriptions.Item label="Nombre">{this.props.datosFormulario.ID_FORMULARIO.NOMBRES}</Descriptions.Item>
                        <Descriptions.Item
                            label="Nacionalidad"> {this.props.datosFormulario.ID_FORMULARIO.ID_PAIS.NOMBRE}</Descriptions.Item>
                        <Descriptions.Item label="Primer apellido">{this.props.datosFormulario.ID_FORMULARIO.PATERNO}</Descriptions.Item>
                        <Descriptions.Item label="Género">{this.props.datosFormulario.ID_FORMULARIO.GENERO}</Descriptions.Item>
                        <Descriptions.Item label="Segundo apellido">{this.props.datosFormulario.ID_FORMULARIO.MATERNO}</Descriptions.Item>
                        <Descriptions.Item label="Email">{this.props.datosFormulario.ID_FORMULARIO.EMAIL}</Descriptions.Item>
                        <Descriptions.Item
                            label="Rut / Pasaporte">{this.parseRut(this.props.datosFormulario.ID_FORMULARIO.RUT_PASAPORTE)}</Descriptions.Item>
                        
                        <Descriptions.Item label="Teléfono">{this.props.datosFormulario.ID_FORMULARIO.TELEFONO}</Descriptions.Item>
                    </Descriptions>
                    <Divider/>
                    <Descriptions column={1} title="">
                        <Descriptions.Item
                            label="Fecha de inicio">{value.ID_SOLICITUD.FECHA_INICIO.substring(8,10)+'-'+value.ID_SOLICITUD.FECHA_INICIO.substring(5,7)+'-'+value.ID_SOLICITUD.FECHA_INICIO.substring(0,4)}</Descriptions.Item>
                        <Descriptions.Item
                            label="Fecha de término">{value.ID_SOLICITUD.FECHA_TERMINO.substring(8,10)+'-'+value.ID_SOLICITUD.FECHA_TERMINO.substring(5,7)+'-'+value.ID_SOLICITUD.FECHA_TERMINO.substring(0,4)}</Descriptions.Item>
                    </Descriptions>

                    <Form ref={form} initialValues={{dates: [moment(value.ID_SOLICITUD.FECHA_INICIO, 'YYYY-MM-DD'), moment(value.ID_SOLICITUD.FECHA_TERMINO, 'YYYY-MM-DD')]}} layout={'vertical'} name="nest-messages" onFinish={onFinish}>

                        <Form.Item name="dates" label={<label className='formvisit-label'>Nueva fecha de término</label>} rules={[{
                            required: true, message: 'Nueva fecha de término es requerida.'},
                            { validator: async (rule, valores) => {
                                //let hoy = new Date().toISOString().split('T')[0]
                                if (!valores[1]){
                                    throw new Error('Debe ingresar una nueva fecha de termino');
                                }
                                let termino = (parseInt(value.ID_SOLICITUD.FECHA_TERMINO.split('-')[0]) + 1) + '-' + value.ID_SOLICITUD.FECHA_TERMINO.split('-')[1] + '-' + value.ID_SOLICITUD.FECHA_TERMINO.split('-')[2]
                                /* if(value[0].format('YYYY-MM-DD') < hoy){
                                    throw new Error('La fecha inicial no puede ser pasada');
                                } */
                                if(valores[1].format('YYYY-MM-DD') > termino){
                                    throw new Error('No puede hacer una prorroga de más de 1 año.')
                                }
                                if(valores[1].format('YYYY-MM-DD') === value.ID_SOLICITUD.FECHA_TERMINO){
                                    throw new Error('Debe ingresar una nueva fecha de termino.');
                                }
                                /* if(value[1].format('YYYY-MM-DD').split('-')[0] > hoy.split('-')[0]){
                                    throw new Error('La visita no puede pasar al siguiente año.')
                                } */
                            }
                            }
                            ]}>
                            <RangePicker
                                style={{borderColor:"#A3AEBB"}}
                                placeholder={["Inicio", "Término"]}
                                //defaultValue={[moment(value.ID_SOLICITUD.FECHA_INICIO, 'YYYY-MM-DD'), moment(value.ID_SOLICITUD.FECHA_TERMINO, 'YYYY-MM-DD')]}
                                disabled={[true, false]}
                            />
                        </Form.Item>

                        <Form.Item name="causal" label={<label className='formvisit-label'>Causal</label>} rules={[{
                            required: true,
                            message: 'Causal es requerida.'
                        }]}>
                            <TextArea style={{width:"60%", border: "1px solid #A3AEBB"}} /* rows={1} showCount maxLength={100} */ />
                            {/* <Input className='formvisit' style={{height: '200px', width: '60%'}}/> */}
                        </Form.Item>
                        <Form.Item>
                            <Button className='global-principal-button' loading={this.state.submitButtonload} style={{marginTop: "20px"}} htmlType="submit">ENVIAR</Button>
                            <Button className='global-secundario-button' style={{marginLeft:'10px'}} onClick={ () => this.props.cerrarDetalle() }> VOLVER </Button>
                        </Form.Item>
                            {/* <Button 
                                type="primary" 
                                htmlType="button"
                                onClick={this.datosCampos}
                            >
                                Borrar campos
                            </Button> */}
                    </Form>
                </div>
            );
        }

        return (
            <div>
                <div>
                    <Modal visible={this.state.modalOk} width={600} style={{textAlign: 'center', color: '#47525E'}} closeIcon=' ' footer={null}>
                            <CheckCircleTwoTone style={{fontSize: "49px"}}twoToneColor="#52c41a"/>
                            <div style={{color:"#5A6978", fontSize: "24px", marginTop: "10px"}}><b>Prorroga exitosa</b></div>
                            <div style={{color:"#8190A5", fontSize: "18px", marginTop: "10px"}}>Se ha modificado la fecha de término de la visita.</div>
                        <Divider/>
                        {/* <Button className='global-secundario-button'><Link to='/main'>MAIN</Link></Button> */}
                        <div style={{textAlign: 'center'}}>
                            <Button className='global-principal-button' onClick={() => window.location.reload()} >ACEPTAR</Button>
                        </div>
                    </Modal>
                    <Modal visible={this.state.modalNotOk} width={600} style={{textAlign: 'center', color: '#47525E'}} closeIcon=' ' footer={null}>
                            <CloseCircleTwoTone style={{fontSize: "49px"}}twoToneColor="#FF4D4F"/>
                            <div style={{color:"#47525E", fontSize: "24px", marginTop: "10px"}}>Ocurrió un error al realizar la prorroga, intentelo nuevamente.</div>
                        <Divider/>
                        {/* <Button className='global-secundario-button'><Link to='/main'>MAIN</Link></Button> */}
                        <div style={{textAlign: 'center'}}>
                            <Button className='global-principal-button' onClick={() => {hideModalNotOk()}} >ACEPTAR</Button>
                        </div>
                    </Modal>
                    <Modal visible={this.state.modalProrrogaOk} width={600} style={{textAlign: 'center', color: '#47525E'}} closeIcon=' ' footer={null}>
                            <ExclamationCircleOutlined style={{fontSize: "49px", color:"#FFBA5C"}}/>
                            <div style={{color:"#47525E", fontSize: "20px", marginTop: "10px"}}>No se puede extender esta visita debido a que tiene otra en el mismo periodo de tiempo</div>
                        <Divider style={{background: '#969FAA'}}/>
                        {/* <Button className='global-secundario-button'><Link to='/main'>MAIN</Link></Button> */}
                        <div style={{textAlign: 'right'}}>
                            <Button className='global-principal-button' onClick={() => {hideModalProrrogaOk()}} >ACEPTAR</Button>
                        </div>
                    </Modal>
                </div>
                {items}
            </div>
        );
    }
}

class TableProrroga extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mostrarTabla: 1,
            visitaSeleccionada: []
        }

    };

    parseRut = rutP =>{
        if(rutP != null){
            let flag_0 = 0;
            let rut_data = rutP;
            let rutPasaporte = '';
            if(rut_data[0] != 'P'){
                for (let i = 0; i < rut_data.length; i++) {
                    if(rut_data[i] != 0){
                        flag_0 = 1;
                    }
                    if(flag_0 == 1){
                        if(i < rut_data.length-1){
                            rutPasaporte = rutPasaporte + rut_data[i]
                        }else{
                            rutPasaporte = rutPasaporte + '-' + rut_data[i]
                        }
                    }
                }
            }else{
                rutPasaporte = rut_data;
            }
            return rutPasaporte;
        }
    }
    mostrarDetalle = data => {
        //console.log(data)
        this.setState({visitaSeleccionada: [data], mostrarTabla: 0});
        
    }

    cerrarDetalle = () => {
        this.setState({mostrarTabla: 1});
        
    }

    componentDidMount() {
        this.setState({mostrarTabla:1})
    }

    // Tabla
    render() {
        const items = [];

        //Mostramos el form resultante para cada rut que encuentre en la búsqueda
        if(this.props.visits.length > 0){
            items.push(
                <Row>
                    <Col span={24}>
                        <Table  dataSource={this.props.visits}>
                            <Column width= "8%" title={<div className='prorroga-title'>Rut/Pasaporte</div>} dataIndex="" render={text => <div className="prorroga-body-data">{this.parseRut(this.props.datosFormulario.ID_FORMULARIO.RUT_PASAPORTE)}</div>}/>
                            <Column width= "10%" title={<div className='prorroga-title'>Nombre</div>} dataIndex="" render={text => <div className="prorroga-body-data">{this.props.datosFormulario.ID_FORMULARIO?.NOMBRES + " " + this.props.datosFormulario.ID_FORMULARIO?.PATERNO + " " + this.props.datosFormulario.ID_FORMULARIO?.MATERNO}</div>}/>
                            <Column width= "10%" title={<div className='prorroga-title'>Fecha de creación</div>} dataIndex="" render={text => <div className="prorroga-body-data">{text.ID_SOLICITUD.FECHA_CREACION.substring(8,10)+'-'+text.ID_SOLICITUD.FECHA_CREACION.substring(5,7)+'-'+text.ID_SOLICITUD.FECHA_CREACION.substring(0,4)}</div>}/>
                            <Column width= "12%" title={<div className='prorroga-title'>Inicio</div>} dataIndex="" render={text => <div className="prorroga-body-data">{text.ID_SOLICITUD.FECHA_INICIO.substring(8,10)+'-'+text.ID_SOLICITUD.FECHA_INICIO.substring(5,7)+'-'+text.ID_SOLICITUD.FECHA_INICIO.substring(0,4)}</div>}/>
                            <Column width= "10%" title={<div className='prorroga-title'>Término</div>} dataIndex="" render={text => <div className="prorroga-body-data">{text.ID_SOLICITUD.FECHA_TERMINO.substring(8,10)+'-'+text.ID_SOLICITUD.FECHA_TERMINO.substring(5,7)+'-'+text.ID_SOLICITUD.FECHA_TERMINO.substring(0,4)}</div>}/>
                            <Column width= "10%" title={<div className='prorroga-title'>Repartición</div>} dataIndex="" render={text => <div className="prorroga-body-data">{text.ID_SOLICITUD?.ID_ORGANISMO.REPARTICION.nombre}</div>}/>
                            <Column width= "15%" title={<div className='prorroga-title'>Organismo</div>} dataIndex="" render={text => <div className="prorroga-body-data">{text.ID_SOLICITUD?.ID_ORGANISMO.ORGANISMO.nombre}</div>}/>
                            <Column width= "15%" title={<div className='prorroga-title'>Departamento</div>} dataIndex="" render={text => <div className="prorroga-body-data">{text.ID_SOLICITUD?.ID_ORGANISMO.DEPARTAMENTO.nombre}</div>}/>
                            <Column width= "10%" title={<div className='prorroga-title'>Realizar Prórroga</div>} dataIndex="" render={text => <Button className='global-principal-button' onClick={ () => this.mostrarDetalle(text) }> Ver detalle </Button> }/>
                        </Table>
                    </Col>
                </Row>
            );
        }

        return (
            <div>
                { this.state.mostrarTabla ? items :
                <div>
                <FormProrroga /* organismos={this.props.organismos} */cerrarDetalle={this.cerrarDetalle} datosFormulario={this.props.datosFormulario} visits={this.state.visitaSeleccionada} history={this.props.history} /* countries={this.props.countries} *//>
                {/* <Button className='global-secundario-button' style={{marginTop:'10px'}} onClick={ () => this.cerrarDetalle() }> VOLVER </Button> */}
                </div>
                }

            </div>
        );
    }

    

}


// Componente que se muestra finalmente
class Prorroga extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visits: [],
            options: [],
            visita: [],
            paises: [],
            dataSource: [],
            dataUser: "",
            organismos: [],
            visitaSinCargar: false,
            datosFormulario: [],
            sinDatos: false
        }

    };
    // Formulario
    render() {
        const validateMessages = {
            required: '${label} es requerido',
            types: {
                email: '${label} no es válido como email',
                number: '${label} no es un número válido',
            },
            number: {
                range: '${label} debe estar entre ${min} y ${max}',
            },
        };

        const searchVisitRut = values => {
            this.setState({visitaSinCargar: true, cargandoDatos: true});
            if(values.rut_pasaporte[0].toUpperCase() != "P"){
                var dataF = values.rut_pasaporte.replace("-","")
                for(let ix=0;ix<10-values.rut_pasaporte.replace("-","").length;ix++){
                    dataF = "0" + dataF
                }
                values.rut_pasaporte = dataF
            }
            values.rut_pasaporte = values.rut_pasaporte.toUpperCase();
            datosProrroga(values.rut_pasaporte).then(responseVisit => {
                if(responseVisit.data.length === 0 || responseVisit.data.visita === null){
                    this.setState({cargandoDatos: false, visitaSinCargar: false, sinDatos: true})
                } else {
                let res= responseVisit.data.visita
                let formulario = responseVisit.data.Formulario
                res.sort(function(a, b) {
                    var textA = a.ID_SOLICITUD.FECHA_CREACION;
                    var textB = b.ID_SOLICITUD.FECHA_CREACION;
                    return (textA > textB) ? -1 : (textA < textB) ? 1 : 0;
                });
                console.log("res:",res)
                console.log("formulario",formulario)
                this.setState({cargandoDatos: false, visitaSinCargar: false, visita: res, datosFormulario: formulario, sinDatos: false});
                }
            }).catch(function (error) {
                console.log("error: ", error)
            });
        }

        return (
            <Spin tip="Cargando Datos…" spinning={this.state.visitaSinCargar}>
                <Card>
                    <div>
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <a href="/main">Menú principal</a>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>Prórroga</Breadcrumb.Item>
                        </Breadcrumb>

                        <div style={{color: "#1978B8", fontSize:"25px", fontWeight: "bold"}}>Ingreso de Prórrogas</div>
                        <Form ref={form} layout={'vertical'} name="nest-messages" onFinish={searchVisitRut} /*initialValues={initial}*/
                          validateMessages={validateMessages}>
                            <Row gutter={[16, 16]}>
                                <Col span={16}>
                                    <Form.Item
                                        name='rut_pasaporte'
                                        //label="RUT / Pasaporte"
                                        label={<label className='formvisit-label'>RUT / Pasaporte</label>}
                                        //style={{ color:"#5A6978", fontFamily:"Roboto", fontSize:"14px" }}
                                        rules={[{required: true, message: 'RUT o Pasaporte es requerido'}, {
                                            message: 'Formato RUT es 12345678-9 o de Pasaporte es P123456789',
                                            pattern: "^(\\d{1,2}\\d{3}\\d{3}-[\\dkK]|P\\w*)$"},
                                            {
                                            validator: async (rule, value) => {
                                                if(!value){
                                                    return;
                                                }
                                                if (value[0] === 'P' && value.length > 5){
                                                    return;
                                                }
                                                if (value.split("-").length < 2 || value.split("-")[1].length != 1) {
                                                    throw new Error('RUT incorrecto.');
                                                    return;
                                                }
                                                let rut = value.split("-")[0];
                                                let verificador = '' + value.split("-")[1];
                                                let verCalc = '';
                                                let sum = 0;
                                                let mul = 2;
                                            
                                                let i = rut.length;
                                                while (i--) {
                                                sum = sum + parseInt(rut.charAt(i)) * mul;
                                                if (mul % 7 === 0) { mul = 2; }
                                                else { mul++; }
                                                }
                                            
                                                const res = '' + sum % 11;

                                                if (res === '0'){
                                                    verCalc = '0';
                                                } else {
                                                    if (res === '1'){
                                                        verCalc = 'k';
                                                    } else {
                                                        verCalc = '' + (11-res)
                                                    }
                                                }
                                                if (verificador.toUpperCase() === verCalc.toUpperCase()){
                                                    return;
                                                } else {
                                                    console.log("DV incorrecto")
                                                    throw new Error('RUT incorrecto.');
                                                }
                                            }
                                        } ]}
                                    >
                                        <Input style={{ width: "100%" }} className='formvisit' placeholder="12345678-9 / P123456789" onBlur={this.handleonChangeRutPasaportev2} />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item>
                                        <Button
                                            style={{marginTop: 30}}
                                            className='formvisit-send-button'
                                            htmlType="submit"
                                            loading={this.state.submitButtonload}
                                        >
                                            ENVIAR
                                        </Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                        {this.state.cargandoDatos ? null : (this.state.sinDatos ? <div>No se encontraron resultados</div> :
                        <TableProrroga datosFormulario={this.state.datosFormulario} visits={this.state.visita} history={this.props.history}/>)
                        }
                </div>
            </Card>
        </Spin>
        );
    }
}

export default Prorroga;